const initVideoProgress = () => {
  const module = document.querySelector('.video-progress');

  if (!module) {
    return;
  }

  const playButton = module.querySelector('#play-video');
  const pauseButton = module.querySelector('#pause-video');
  const video = module.querySelector('.video-progress__video');
  const disclaimerText = module.querySelector('.video-progress__video-disclaimer');
  const completionText = module.querySelector('.video-progress__video-completion-text');
  const progressBar = module.querySelector('.video-progress__bar-fill');
  const progressText = module.querySelector('.video-progress__text');
  const cookieName = module.getAttribute('data-cookie-name') || 'video_progress_complete';

  if (!playButton || !pauseButton || !video || !progressBar || !progressText) {
    return;
  }

  const setCookie = (name, value, days = 30) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/`;
  };

  const getCookie = (name) => {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i += 1) {
      const cookie = cookies[i].trim();

      if (cookie.indexOf(nameEQ) === 0) {
        return decodeURIComponent(cookie.substring(nameEQ.length));
      }
    }

    return null;
  };

  const markComplete = () => {
    progressBar.style.width = '100%';
    progressText.textContent = '100% Complete';

    if (disclaimerText) {
      disclaimerText.classList.add('uk-hidden');
    }

    if (completionText) {
      completionText.classList.remove('uk-hidden');
    }
  };

  const markIncomplete = () => {
    progressBar.style.width = '0%';
    progressText.textContent = '0% Complete';

    if (disclaimerText) {
      disclaimerText.classList.remove('uk-hidden');
    }

    if (completionText) {
      completionText.classList.add('uk-hidden');
    }
  };

  video.controls = false;
  video.setAttribute('controlsList', 'nodownload noplaybackrate nofullscreen');
  video.disablePictureInPicture = true;

  // Initial state. Watching the video is optional, so this only reflects
  // progress; the CTA button stays available either way.
  if (getCookie(cookieName) === 'completed') {
    markComplete();
  } else {
    markIncomplete();
  }

  playButton.addEventListener('click', function (e) {
    e.preventDefault();

    video.play().catch(function (error) {
      console.error('Video could not be played:', error);
    });

    playButton.classList.add('uk-hidden');
    pauseButton.classList.remove('uk-hidden');
  });

  pauseButton.addEventListener('click', function (e) {
    e.preventDefault();

    video.pause();

    pauseButton.classList.add('uk-hidden');
    playButton.classList.remove('uk-hidden');
  });

  video.addEventListener('timeupdate', function () {
    if (!video.duration || Number.isNaN(video.duration)) {
      return;
    }

    const percent = Math.min((video.currentTime / video.duration) * 100, 100);
    const roundedPercent = Math.floor(percent);

    progressBar.style.width = `${percent}%`;
    progressText.textContent = `${roundedPercent}% Complete`;
  });

  video.addEventListener('ended', function () {
    setCookie(cookieName, 'completed', 30);
    markComplete();

    pauseButton.classList.add('uk-hidden');
    playButton.classList.remove('uk-hidden');
  });
};

export default initVideoProgress;
